<script setup lang="ts">
import { useRoute } from "vue-router";
import AppShell from "./components/layout/AppShell.vue";
import ToastHost from "./components/ui/ToastHost.vue";
import ConfirmHost from "./components/ui/ConfirmHost.vue";
import RouteErrorBoundary from "./components/ui/RouteErrorBoundary.vue";
import AssistantWidget from "./components/ai/AssistantWidget.vue";
import { useAuthStore } from "./stores/auth";
import { computed } from "vue";

const route = useRoute();
const auth = useAuthStore();

// Pages that render bare (no AppShell): login, public preferences center, 404.
// NEW-DEMO-2026-08-07-02: публичные bare-префиксы как fallback по pathname — чтобы даже до
// разрешения роутера (первый кадр) публичная ссылка опроса НЕ мелькала админ-shell'ом.
const BARE_PATH_PREFIXES = ["/s/", "/q/", "/r/", "/p/", "/login", "/preferences"];
const isBarePage = computed(
  () => route.meta.bare === true || BARE_PATH_PREFIXES.some((p) => location.pathname.startsWith(p)),
);
const ready = computed(() => auth.bootstrapped);
</script>

<template>
  <div v-if="!ready" class="flex h-screen items-center justify-center">
    <div class="text-surface-400 text-sm">Загрузка…</div>
  </div>
  <template v-else>
    <RouteErrorBoundary v-if="isBarePage">
      <router-view />
    </RouteErrorBoundary>
    <AppShell v-else>
      <RouteErrorBoundary>
        <router-view />
      </RouteErrorBoundary>
      <!-- Global floating AI-marketer (FIX-AI-6) — follows the operator everywhere. -->
      <AssistantWidget />
    </AppShell>
  </template>
  <ToastHost />
  <ConfirmHost />
</template>
